import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";

import Grid from "@mui/material/Grid2";
import { StyledEngineProvider } from "@mui/material/styles";

export default function GDPLineChart(props: any) {
  return (
    <Grid size={1}>
      <div className="whiteBG">
        <h3>{props.yLabel}</h3>
        <StyledEngineProvider injectFirst>
          <LineChart
            height={240}
            margin={{ top: 55, right: 6, bottom: 30, left: 16 }}
            series={[
              {
                data: props.yData,
                label: "实际值",
                id: "real",
                color: "#8b0012",
              },
              {
                data: props.prData,
                label: "预测值",
                id: "pr",
                color: "#392f30",
              },
            ]}
            xAxis={[
              {
                scaleType: "point",
                data: props.xLabels,
                tickLabelStyle: { fontSize: 10 },
              },
            ]}
            slotProps={{
              legend: {
                hidden: false,
                itemMarkHeight: 2,
                direction: "row",
              },
            }}
            sx={{
              ["& .MuiLineElement-root, & .MuiMarkElement-root"]: {
                strokeWidth: 2,
                fill: "#fff",
                stroke: "none",
              },
              // 设置虚线格式
              ".MuiLineElement-series-pr": {
                strokeDasharray: "5 5",
              },
            }}
          />
        </StyledEngineProvider>
        <p className="updateDate">注：图中数据为{props.indicator}</p>
        <p className="updateDate">更新时间：{props.updateDate}</p>
      </div>
    </Grid>
  );
}
